import { type Common } from './common.js';
import type * as EhrTimeSlot from './models/ehrTimeSlot.js';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  reschedule(params: EhrTimeSlot.AppointmentReschedulingBookingParams) {
    const url = this.common.constructPath(`/patient-previsit/reschedule-ehr-time-slot`);
    return this.common.postJSON(url, params);
  }

  getRescheduleSlots(
    query: EhrTimeSlot.AppointmentReschedulingFetchingParams
  ): Promise<Pick<EhrTimeSlot.AvailableEhrTimeSlotResponse, 'availableEhrTimeSlots'>> {
    const url = this.common.constructPath(`/patient-previsit/reschedule-ehr-time-slot`, query);
    return this.common.getJSON(url, undefined, true);
  }
}
